import React from 'react';

import { SkeletonLoader } from 'common/react/components/SkeletonLoader';

/**
 * Displays a loading state for the Sponsor component.
 *
 * @param cssClass
 * @returns The Sponsor component skeleton loader.
 */
export const SponsorSkeleton = (cssClass) => (
    <div
        className={`${cssClass} content-sponsor content-sponsor--without-borders content-sponsor--without-padding`}
    >
        <div className="content-sponsor__title">
            <SkeletonLoader width={150} height={14} />
        </div>
        <div className="content-sponsor__image-link">
            <div className="u-hide-until-tablet">
                <SkeletonLoader width={150} height={60} />
            </div>
            <div className="u-hide-from-tablet">
                <SkeletonLoader width={150} height={48} />
            </div>
        </div>
    </div>
);
